<template>
  <div class="dashboard-promo-banner" :class="{open: isOpen}">
    <a :href="bannerLink" @click="showBfModal" class="banner--content">
      <div class="banner-content-wrap">
        <div class="banner--content__left">
          <img class="bf-logo" src="/static/images/black-friday-logo-en.png" alt="">
          <!-- Main promo banner -->
          <template v-if="bannerType === 'promo'">
            <div class="promo" v-html="promoData.banner_message" />
          </template>
          <!-- Pre promo banner -->
          <template v-if="bannerType === 'pre'">
            <div class="prepromo">
              <p v-html="$gettext('THIS FRIDAY = BLACK FRIDAY')" />
              <p class="secondary"> {{ $gettext('ONE YEAR OF PREMIUM FOR 80,-') }}</p>
              <p class="tertiary" v-html="$gettext('MORE THAN <span class=\'banner-price-tag\'>40% OFF</span>!')" />

            </div>
          </template>
        </div>
        <div v-if="bannerType === 'promo' && promoEnds" class="banner--content__right">
          <div class="flip-count">
            <span class="flip-title">{{ $gettext('Ends in') }}</span>
            <FlipCount :time-until="promoEnds" />
          </div>
        </div>
        <div v-if="false && bannerType === 'pre'" class="banner--content__right"> <!-- disabled -->
          <div class="pre-deadline" v-html="$gettext('24 hours <br class=\'hidden sm:block\'>discount')" />
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import FlipCount from "@/components/dashboard/ui/FlipCount"
import moment from 'moment';
export default {
  name: "PromoBanner",
  components: {
    FlipCount
  },
  props: {
    promoData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isOpen: false,
      promoEnds: null,
      bannerType: null,
      debug: false
    }
  },
  computed: {
    bannerLink () {
      return (this.bannerType === 'pre') ? '' : '/subscriptions/manage/?selected=year'
    }
  },
  created () {
    if (this.promoData) {
      // format MM/DD/YYYY
      // Promo dates
      const to = moment(this.promoData.end_date).format('MM/DD/YYYY')  //'11/26/2022'

      const promoDuration = 1

      const dateToday = new Date()
      const dateTo = new Date(to)
      dateTo.setDate(dateTo.getDate() + promoDuration) // new Date() will set hour to 00:00:00
      this.promoEnds = moment(dateTo).format('MM/DD/YYYY')

      // check if today is between start and end promo dates to show the banner
      this.bannerType = (dateToday < new Date(to)) ? 'pre' : 'promo'
    } else {
      this.bannerType = 'pre'
    }
  },
  mounted () {
    setTimeout(() => {
      this.isOpen = true
    }, 1000)
  },
  methods: {
    showBfModal (e) {
      if (this.bannerType === 'pre') {
        this.$emit('show-promo-modal', false)
        e.preventDefault()
      }
    }
  }
}
</script>
<style lang="scss">
.dashboard-promo-banner,
.dashboard-promo-banner-heroes {
  .banner-price-tag {
    position: relative;
    display: inline;
    &:before {
      content: '';
      position: absolute;
      bottom: -3px;
      left: 0;
      width: 0;
      height: 4px;
      background: white;
      transition: width 1s ease-in-out;
      transition-delay: 1s;
    }
  }
  &.open {
    .banner-price-tag {
      &:before {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
  .dashboard-promo-banner {
    cursor: pointer;
    display: flex;
    align-items: center;
    background: linear-gradient(103deg, rgba(206,36,47,1) 43%, rgba(140,25,32,1) 61%, rgba(0,0,0,1) 78%);
    height: 0px;
    overflow: hidden;
    transition: height 0.8s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    margin-bottom: 0.5rem;
    .banner--content {
      &:hover {
        text-decoration: none;
      }
      display: flex; 
      padding: 0.75rem;
      font-weight: 900; 
      flex-direction: column; 
      justify-content: center; 
      width: 100%; 
      max-width: 80rem; 
      height: 100%; 

      @media (min-width: 640px) { 
        padding-left: 1.5rem;
        padding-right: 1.5rem; 
      }

      @media (min-width: 1024px) { 
        padding-left: 2rem;
        padding-right: 2rem; 
      }

      transition: all 0.5s cubic-bezier(0.750, 0.020, 0.190, 1.290);
      opacity: 0;
      transform: scale(0.9);
      .banner-content-wrap {
        display: flex; 
        flex-wrap: wrap; 
        justify-content: space-between; 
        align-items: center; 
      }
      &__left {
        display: flex; 
        flex-direction: column; 
        align-items: center; 
        width: 100%; 

        @media (min-width: 640px) { 
          flex-direction: row; 
          flex: 1 1 0%; 
          width: 0; 
        }

        .promo {
          display: flex; 
          margin-top: 0.5rem; 
          color: #ffffff; 
          font-size: 1.25rem;
          line-height: 1.75rem; 
          text-align: center; 
          flex-direction: column; 
          justify-content: center; 
          align-items: center; 
          width: 100%; 

          @media (min-width: 640px) { 
            margin-top: 0; 
            margin-left: 1.5rem; 
            font-size: 1.5rem;
            line-height: 2rem; 
          }

          @media (min-width: 1024px) { 
            font-size: 1.875rem;
            line-height: 2.25rem; 
          }

          .promo-title {
            font-size: 0.75rem;
            line-height: 1rem; 
            @media (min-width: 640px) { 
              font-size: 0.875rem;
              line-height: 1.25rem; 
            }
          }
          .promo-slogan-1 {
            display: block; 
            margin-top: 0.25rem;
            margin-bottom: 0.25rem; 
            line-height: 1.25; 
            text-transform: uppercase; 
          }
          .promo-slogan-2 {
            display: block; 
            font-size: 0.875rem;
            line-height: 1.25rem; 
            text-transform: uppercase; 
            @media (min-width: 640px) { 
              font-size: 1rem;
              line-height: 1.5rem; 
            }
            @media (min-width: 1024px) { 
              font-size: 1.125rem;
              line-height: 1.75rem; 
            }
          }
        }
        .bf-logo {
          width: 65px;
          @media (min-width: 640px) { width: 90px; }
          @media (min-width: 768px) { width: 130px; }
          @media (min-width: 1024px) { width: 200px; }
        }
        .prepromo {
          margin-top: 0.5rem; 
          color: #ffffff; 
          font-size: 1.25rem;
          line-height: 1.75rem; 
          text-align: center; 
          width: 100%;
          p { margin: 0; margin-bottom: 0.5rem;}
          @media (min-width: 640px) { 
            font-size: 1.875rem;
            line-height: 2.25rem; 
          }
          p.secondary {
            text-transform: uppercase;
            margin-bottom: 0;
            @media (min-width: 640px) { 
              font-size: 18px;
              line-height: 24px;
            }
            @media (min-width: 1024px) { 
              font-size: 22px;
              line-height: 28px; 
            }
          }
          p.tertiary {
            font-size: 16px;
            line-height: 20px;
            margin-bottom: 0;
            @media (min-width: 640px) { 
              font-size: 18px;
              line-height: 20px;
            }
          }

        }
      }
      &__right {
        display: flex; 
        margin-top: 0.25rem; 
        flex-shrink: 0; 
        order: 3; 
        justify-content: center; 
        width: 100%; 

        @media (min-width: 640px) { 
          margin-top: 0; 
          margin-right: 3rem; 
          order: 2; 
          width: auto; 
        }
        .pre-deadline {
          display: flex; 
          color: #ffffff; 
          font-size: 1.125rem;
          line-height: 1.75rem; 
          text-transform: uppercase; 
        }
        .flip-count {
          display: flex; 
          color: #ffffff; 
          font-size: 0.875rem;
          line-height: 1.25rem; 
          text-align: center; 
          text-transform: uppercase; 

          @media (min-width: 640px) { 
            flex-direction: column; 
          }
          .flip-title {
            margin-bottom: 0.5rem; 
          }
        }
      }
    }
    &.open {
      height: 200px;
      .banner--content {
        opacity: 1;
        transform: scale(1);
        transition-delay: 0.5s;
      }
    }
    @media (min-width: 640px) {
      &.open {
        height: 200px;
      }
    }
    
  }
</style>
